import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import update from "immutability-helper";
import { get, map } from "lodash";

import Box from "@material-ui/core/Box";

import DatePicker from "../../Common/DatePicker";
import CustomButton from "../../Common/CustomButton";
import FormSection from "../../Common/FormSection";
import CompaniesSitesZonesSelect from "../../Common/CompaniesSitesZonesSelect";

import { nowWithOutSeconds } from "../../../utils/date";

const availablePeriods = [
  {
    name: "today",
    daysNumber: "0",
  },
  {
    name: "yesterday",
    daysNumber: 1,
  },
  {
    name: "last2days",
    daysNumber: 2,
  },
  {
    name: "last7days",
    daysNumber: 7,
  },
  {
    name: "custom",
    daysNumber: "custom",
  },
];

const styles = {
  gridLine: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, 200px)",
    gridAutoRows: "56px",
    gridGap: "24px",
    padding: "24px",
  },
};

const MdcInventoryForm = (props) => {
  const { classes, search } = props;

  const [filters, setFilters] = React.useState({
    dateFilter: "0",
  });

  const handleChange = (id, index, value) => {
    if (id === "period") {
      if (value === "custom") {
        setFilters(
          update(filters, {
            dateFilter: { $set: "custom" },
            startDate: { $set: nowWithOutSeconds() - 86400000 },
            endDate: { $set: nowWithOutSeconds() },
          })
        );
      } else {
        const now = new Date();
        const midnight = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          0,
          0,
          0
        );
        const startDate =
          value === "0"
            ? midnight.getTime()
            : new Date(midnight - 86400000 * value).getTime();
        const endDate =
          value === "0" ? midnight.getTime() + 86400000 : midnight.getTime();

        setFilters(
          update(filters, {
            dateFilter: { $set: value },
            startDate: { $set: startDate },
            endDate: { $set: endDate },
          })
        );
      }
    } else {
      setFilters(
        update(filters, {
          [id]: { $set: value },
        })
      );
    }
  };

  const handleChangeDate = (id, value) => {
    setFilters(
      update(filters, {
        [id]: { $set: new Date(value).getTime() },
      })
    );
  };

  return (
    <Box className={classes.gridLine}>
      <Box>
        <CompaniesSitesZonesSelect
          formValue={get(filters, ["zones"])}
          setFormValue={(values) => handleChange("zones", null, values)}
        />
      </Box>
      <Box>
        <FormSection
          formValue={[get(filters, ["dateFilter"])]}
          setFormValue={handleChange}
          title={"period"}
          id={"period"}
          type="select"
          options={{
            noSort: true,
            options: map(availablePeriods, (p) => ({
              id: p.daysNumber,
              name: I18n.get(`dashboard_${p.name}`),
            })),
          }}
        />
      </Box>
      {get(filters, ["dateFilter"]) === "custom" && (
        <>
          <Box>
            <DatePicker
              label={I18n.get("site_startDate")}
              name="startDate"
              value={get(filters, ["startDate"])}
              onChange={handleChangeDate}
              width={200}
            />
          </Box>
          <Box>
            <DatePicker
              label={I18n.get("site_endDate")}
              name="endDate"
              value={get(filters, ["endDate"])}
              onChange={handleChangeDate}
              width={200}
            />
          </Box>
        </>
      )}
      <Box style={{ display: "flex", alignItems: "flex-end" }}>
        <CustomButton
          variant="contained"
          color="primary"
          onClick={() => search(filters)}
          style={{ marginTop: "4px" }}
        >
          {I18n.get("dashboard_search")}
        </CustomButton>
      </Box>
    </Box>
  );
};

export default withStyles(styles)(MdcInventoryForm);
